import { Store } from 'store';

const getFrameUpsellFrameTitle = (store: Store) =>
  store.product.frameUpsellPopupData?.items[store.product.frameUpsellSelectedFrame || 0]?.name;
export default getFrameUpsellFrameTitle;
